import { useEffect, useState } from 'react';
import offeringService from '../services/offering.service';

export interface OfferingMarkets {
  /** The countries switched on, once read; null while reading or when it could not be read. */
  markets: readonly string[] | null;
  /** True when the answer could not be read: the notice then says it without naming a country. */
  unavailable: boolean;
}

/** The countries the offering is made in, as the country switch says today. */
export function useOfferingMarkets(): OfferingMarkets {
  const [state, setState] = useState<OfferingMarkets>({ markets: null, unavailable: false });

  useEffect(() => {
    let cancelled = false;
    offeringService
      .markets()
      .then((markets) => {
        if (!cancelled) setState({ markets, unavailable: false });
      })
      .catch(() => {
        if (!cancelled) setState({ markets: null, unavailable: true });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
